export default "__VITE_ASSET__BI7BvKb8__"